
    var riot = require('riot')
    
import vars from '@/vars'
riot.tag2('top-mv', '<div class="view"> <div class="item" if="{mode == &quot;pc&quot;}" each="{data in mv}" data-band="{data.band}" data-header="{data.header}" riot-style="background-image: url({data.bg});"> <top-mv-image data="{data}"></top-mv-image> </div> <div class="item" if="{mode == &quot;sp&quot;}" each="{data in mv}" data-band="{data.band}" data-header="{data.header}"> <top-mv-image data="{data}"></top-mv-image> </div> </div> <div class="top__cv__banner"> <div class="top__cv__banner__wrap"> <p class="banner" each="{bn}"><a href="{href}" target="{target}" data-gatitle="{ga} {href}"><img class="lazy-img" alt="" src="/design/img/cmn/bn-loading.png" data-src="{img}"></a></p> </div> </div>', '', '', function(opts) {

    const self = this
    console.log(self)

    self.mv = self.opts.store.mainvisuals
    self.bn = self.opts.store.campaign_banners

    self.on('mount', () => {
      vars.uacheck(self)
      self.update()

      $(".lazy-img", self.root).Lazy({
        effect: 'fadeIn',
        effectTime: 400
      })

      $(".view", self.root).slick({
        slidesToShow: 1,
        autoplay: true,
        pauseOnHover: false,
        pauseOnDotsHover: true,
        fade: true,
        arrows: false,
        dots: true,

        customPaging: function(slider, i) {
          return '<p>'+ (i + 1) +'</p>';
        },

        onInit: function(){
          setTimeout(function(){
            let $t = $(".item.slick-active", self.root);
            $("#header").attr("data-color", $t.data("header"));
            $("html").attr("data-color", $t.data("header"));
          }, 10);
        },

        onBeforeChange: function(){
          setTimeout(function(){
            let $t = $(".item.slick-active", self.root);
            $("#header").attr("data-color", $t.data("header"));
            $("html").attr("data-color", $t.data("header"));
          }, 10);
        }
      });
    })
});
    
  


// WEBPACK FOOTER //
// ./_src/js/riot/top-mv.tag